"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollable = void 0;
var Scrollable_1 = require("./Scrollable");
Object.defineProperty(exports, "Scrollable", { enumerable: true, get: function () { return Scrollable_1.Scrollable; } });
